// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/semantic.css
 ** module id = 2
 ** module chunks = 3
 **/